import { __ } from '@wordpress/i18n';
import { InspectorControls, BlockControls, AlignmentToolbar } from '@wordpress/block-editor';
import { PanelBody, PanelRow, TextControl, ToggleControl, Dashicon, SelectControl } from '@wordpress/components';

// Settings Components
import Title from '../../Components/Title';
import SpaceControl from '../../Components/SpaceControl';

import { types, sizes } from './utils/options';

const Settings = ({ attributes, setAttributes }) => {
	const { skypeID, type, isWhite, size, alignment, padding } = attributes;

	return <>
		<InspectorControls>
			<PanelBody className='bPlPanelBody help' title={__('Help', 'skype-button')} initialOpen={false}>
				<div className='helpItem'>
					<a href='https://bblockswp.com/docs/skype-button-block/' target='_blank' rel='noreferrer'><Dashicon icon='book' />{__('Read Documentation', 'skype-button')}</a>
				</div>

				<div className='helpItem rateUs'>
					<a href='https://wordpress.org/support/plugin/skype-button-block/reviews/#new-post' target='_blank' rel='noreferrer'>
						<span><Dashicon icon='star-filled' />{__('Would you please rate us?', 'skype-button')}</span>
						<span>{__('We are new and we need your help to grow!🙏', 'skype-button')}</span>
					</a>
				</div>
			</PanelBody>


			<PanelBody className='bPlPanelBody' title={__('Skype Button Settings', 'skype-button')}>
				<Title className='mb5'>{__('Skype ID:', 'skype-button')}</Title>
				<TextControl value={skypeID} onChange={val => setAttributes({ skypeID: val })} />

				<PanelRow>
					<Title className=''>{__('Type:', 'chart-block')}</Title>
					<SelectControl value={type} onChange={val => {
						setAttributes({ type: val });
						setAttributes({ padding: 'dropdown' === val ? { side: 4, bottom: '100px' } : { side: 2, bottom: '0px' } })
					}} options={types} />
				</PanelRow>

				<ToggleControl className='mt20' label={__('Logo White Color', 'skype-button')} checked={isWhite} onChange={val => setAttributes({ isWhite: val })} />

				<PanelRow>
					<Title className=''>{__('Size:', 'chart-block')}</Title>
					<SelectControl value={size} onChange={val => setAttributes({ size: parseInt(val) })} options={sizes} />
				</PanelRow>

				<SpaceControl className='mt20' label={__('Padding:', 'skype-button')} value={padding} onChange={val => setAttributes({ padding: val })} />
			</PanelBody>
		</InspectorControls>


		<BlockControls>
			<AlignmentToolbar value={alignment} onChange={val => setAttributes({ alignment: val })} describedBy={__('Skype Button Alignment')} alignmentControls={[
				{ title: __('Skype Button in left', 'skype-button'), align: 'left', icon: 'align-left' },
				{ title: __('Skype Button in center', 'skype-button'), align: 'center', icon: 'align-center' },
				{ title: __('Skype Button in right', 'skype-button'), align: 'right', icon: 'align-right' }
			]} />
		</BlockControls>
	</>;
};
export default Settings;